<template>
<div>
  <div
    class="catalog"
    v-for="(h2,key) in category"
    :data-key="key"
    :key="key">
    <h2 v-if="key != 0">{{h2.name}}</h2>
    <products
      v-on:stopBodyScroll="stopBodyScroll"
      v-on:alertTips="alertTips"
      :category="category[key].id"
      :categoryIndex="key"
      :shoppingCart="shoppingCart"
      :scrollY="scrollY"
      @itemall="itemall"
      @addcart="setaddcart" />
  </div>

  <fixMenu
    :scrollY="scrollY"
    :category="category"
    @catalogNum="catalogTarget"
    v-on:closeDetail="closeDetail"
    :itemAll="itemAll"
    :isAddCart="addcart"
    @finishaddcart="resetcart"
    v-on:getCartItems="getCartItems" />

  <alert
    v-if="showAlert"
    v-on:closeAlertTips="closeAlertTips"
    :message="showAlertMsg" />
</div>
</template>

<script>
import alert from "./alert.vue";
import fixMenu from "./fixMenu.vue";
import products from "./products.vue";
export default {
  name: "catalog",
  data() {
    return {
      showAlert: false,
      showAlertMsg: "",
      isStopScrolling: false,
      category: [],
      categoryNum: 1,
      itemAll: {},
      addcart: false,
      shoppingCart: []
    }
  },
  props: {
    scrollY: {
      type: Number,
      defaults: 0,
    }
  },
  created() {
    const cache = this.storage.get('bestshop_category_data', true)
    if (cache) {
      this.category = cache
      this.categoryNum = cache.length
    } else {
      this.axios.get('api/category/879/bottom?hidden=1').then(res => {
        this.category = res.data.payload[0].categories
        this.categoryNum = res.data.payload[0].categories.length
        if (res.data && res.data.payload[0] && res.data.payload[0].categories) {
          this.storage.set('bestshop_category_data', res.data.payload[0].categories, this.configs.webCacheExpireTime, true)
        }
      })
    }

  },
  methods: {
    getCartItems(items) {
      this.shoppingCart = [];
      this.shoppingCart = items
    },
    resetcart() {
      this.addcart = false
    },
    setaddcart() {
      this.addcart = true;
    },
    itemall(v) {
      this.itemAll = Object.assign({}, this.itemAll, v)
    },
    catalogTarget(i) {
      const catalogs = [...document.querySelectorAll('.catalog')]
      const catalogSelTop = catalogs[i].offsetTop;
      window.scrollTo({
        top: catalogSelTop,
        behavior: "smooth"
      })
    },
    alertTips(message) {
      this.showAlertMsg = message;
      this.showAlert = true;
    },
    closeDetail() {
      this.showDetail = false;
    },
    closeAlertTips() {
      this.showAlert = false;
    },
    stopBodyScroll(action) {
      const body = document.querySelector("html");
      if (!this.isStopScrolling) {
        body.style = "padding:0;margin:0;overflow:hidden;height:100%";
        this.isStopScrolling = !this.isStopScrolling;
      }
      if (action === "close") {
        body.style = "padding:0;margin:0;";
        this.isStopScrolling = false;
      }
    }
  },
  components: {
    products,
    fixMenu,
    alert,
  }
}
</script>

<style lang="scss" scoped>
.catalog {
  @media(max-width:768px) {
    padding: 0 10px;
  }

  h2 {
    border-radius: 5px;
    text-align: center;
    padding: 25px 0;
    margin-bottom: 20px;
    color: #fff;
    background: url(../../assets/section-title-bg@2x.png) no-repeat;
    background-size: cover;
    background-position-x: right;
    font-size: 1.125rem;

    @media(max-width:768px) {
      padding: 13px 0;
    }
  }
}
</style>
